import { useQuery } from '@tanstack/react-query'
import { graphqlClient } from '@/core/api/graphql-client'
import { CollectionPendingChangesDocument } from '@/generated/graphql'

/** Exported so the moments that change the answer can invalidate it without restating the key. */
export const COLLECTION_DOT_KEY = ['collection', 'pending-changes']

/**
 * Whether the Collection tab wears its dot: cards changed and the reveal queue has not been seen.
 *
 * React's own query rather than the shared module's, because the dot has to show while another tab
 * is open and the bundle only exists while /collection is mounted.
 */
export function useCollectionDot(enabled: boolean): boolean {
  const { data } = useQuery({
    queryKey: COLLECTION_DOT_KEY,
    queryFn: () => graphqlClient.request(CollectionPendingChangesDocument),
    enabled,
    // The queue is claimed inside the tab, which invalidates this; between those it can go stale.
    staleTime: 60_000,
  })
  return data?.myCollection.hasPendingChanges === true
}
